/**
 * Dynamic WebSocket URL resolver
 * Automatically detects the current domain and returns the appropriate WebSocket URL
 */
import { getCurrentConfig, logEnvironmentConfig } from './environmentConfig';

/**
 * Get the appropriate WebSocket URL based on the current domain
 */
export const getWebSocketUrl = (): string => {
  const config = getCurrentConfig();
  return config.wsUrl;
};

/**
 * Log the current WebSocket configuration for debugging
 */
export const logWebSocketConfig = (): void => {
  logEnvironmentConfig();
};
